"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UIComponent = require("../../components/UIComponent.js"),
    template = require("./tabs.html"),
    ContactTab = require("./Contact/contactTab.js"),
    LeadHistoryTab = require("./LeadHistory/leadHistoryTab.js"),
    RentalCriteriaTab = require("./RentalCriteria/rentalCriteriaTab.js"),
    CommunicationTab = require("./Communication/communicationTab.js"),
    TrackingTab = require("./Tracking/trackingTab.js"),
    Customizable = require("../Customization/Customization.js");
var Tabs = function (_UIComponent) {
  _inherits(Tabs, _UIComponent);

  function Tabs() {
    var _this;

    _classCallCheck(this, Tabs);

    (_this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, template)), _this), _this.currentTab = null, _this.previousTab = null, _this.unsavedChanges = !1, _this.contact = new ContactTab(), _this.rental = new RentalCriteriaTab(), _this.history = new LeadHistoryTab(), _this.communication = new CommunicationTab(), _this.tracking = new TrackingTab(), _this.ob = {}, _this.leadId = null, _this.emailId = null, _this.guestCard = null;return _this;
  }

  _createClass(Tabs, [{
    key: "onComponentRendering",
    value: function onComponentRendering(t, a, i) {
      i && i.tab && (t.tab = i.tab, i.subtab && (t.subtab = i.subtab)), i && i.emailId && (this.emailId = i.emailId), this.leadId = a;
    }
  }, {
    key: "onComponentReadyAsync",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(t) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                $("#table-filters>ul>li.active").removeClass("active");
                this.bindWatcher();
                _context.next = 4;
                return this.loadTab(this.data.tab || "contact", !0);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onComponentReadyAsync(_x) {
        return _ref.apply(this, arguments);
      }

      return onComponentReadyAsync;
    }()
  }, {
    key: "loadAlltabs",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var t, a, i, e, s;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = this.rental.renderAsync(this.data, this.leadId), a = this.contact.renderAsync(this.data, this.leadId), i = this.history.renderAsync(this.data, this.leadId), e = this.communication.renderAsync(this.data, this.leadId), s = this.tracking.renderAsync(this.data, this.leadId);
                _context2.t0 = Promise;
                _context2.t1 = this;
                _context2.next = 5;
                return t;

              case 5:
                _context2.t2 = _context2.sent;
                _context2.t3 = _context2.t1.getRequiredFields.call(_context2.t1, _context2.t2);
                _context2.t4 = this;
                _context2.next = 10;
                return a;

              case 10:
                _context2.t5 = _context2.sent;
                _context2.t6 = _context2.t4.getRequiredFields.call(_context2.t4, _context2.t5);
                _context2.t7 = this;
                _context2.next = 15;
                return i;

              case 15:
                _context2.t8 = _context2.sent;
                _context2.t9 = _context2.t7.getRequiredFields.call(_context2.t7, _context2.t8);
                _context2.t10 = this;
                _context2.next = 20;
                return e;

              case 20:
                _context2.t11 = _context2.sent;
                _context2.t12 = _context2.t10.getRequiredFields.call(_context2.t10, _context2.t11);
                _context2.t13 = this;
                _context2.next = 25;
                return s;

              case 25:
                _context2.t14 = _context2.sent;
                _context2.t15 = _context2.t13.getRequiredFields.call(_context2.t13, _context2.t14);
                _context2.t16 = [_context2.t3, _context2.t6, _context2.t9, _context2.t12, _context2.t15];
                _context2.next = 30;
                return _context2.t0.all.call(_context2.t0, _context2.t16);

              case 30:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadAlltabs() {
        return _ref2.apply(this, arguments);
      }

      return loadAlltabs;
    }()
  }, {
    key: "reloadActions",
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.history.renderAsync(this.data, this.leadId);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function reloadActions() {
        return _ref3.apply(this, arguments);
      }

      return reloadActions;
    }()
  }, {
    key: "validateData",
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(t) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.tracking.validateData(t);

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function validateData(_x2) {
        return _ref4.apply(this, arguments);
      }

      return validateData;
    }()
  }, {
    key: "getRequiredFields",
    value: function getRequiredFields(t) {
      return Customizable.cloak(t);
    }
  }, {
    key: "bindWatcher",
    value: function bindWatcher() {
      var _this2 = this;

      this.data = this.observe(this.data, function (t, a) {
        _this2.unsavedChanges = !0;
      });
    }
  }, {
    key: "loadTab",
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(t) {
        var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

        var _a, i;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.currentTab !== t || a)) {
                  _context5.next = 18;
                  break;
                }

                this.previousTab = this.currentTab, this.currentTab = t;_a = $(this.refs[t]);
                "function" == typeof this[t].setGuestCard && this[t].setGuestCard(this.guestCard);i = this[t];
                this[this.previousTab] && this[this.previousTab].detach();
                _a.hasClass("inactive-tab") && $(".tabs li").each(function () {
                  $(this).removeClass("active-tab").addClass("inactive-tab");
                });

                _a.removeClass("inactive-tab");

                _a.addClass("active-tab");

                i.attach($(this.refs.tabBody).empty());

                if (!("communication" === this.currentTab && this.emailId)) {
                  _context5.next = 15;
                  break;
                }

                _context5.next = 13;
                return this[t].renderAsync(this.data, this.leadId, this.emailId);

              case 13:
                _context5.next = 17;
                break;

              case 15:
                _context5.next = 17;
                return this[t].renderAsync(this.data, this.leadId);

              case 17:
                this.emit("tabShown");

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loadTab(_x3) {
        return _ref5.apply(this, arguments);
      }

      return loadTab;
    }()
  }, {
    key: "setGuestCard",
    value: function setGuestCard(t) {
      this.guestCard = t;
    }
  }]);

  return Tabs;
}(UIComponent);

module.exports = Tabs;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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